export default "/_next/static/images/53080a0c71a06fa60441bb6f645aceae.png";